/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChannelsBulkJobsRequest } from '../../models/channels-bulk-jobs-request';
import { HalJson } from '../../models/hal-json';

export interface ChannelsBulkJobsPost$Params {
  'Active-Tenant-Identifier': string;
      body: ChannelsBulkJobsRequest
}

export function channelsBulkJobsPost(http: HttpClient, rootUrl: string, params: ChannelsBulkJobsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'jobId'?: string;
'status'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, channelsBulkJobsPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      'jobId'?: string;
      'status'?: string;
      }>;
    })
  );
}

channelsBulkJobsPost.PATH = '/channels/bulk-jobs';
